export default "__VITE_ASSET__DCJ5Uvy2__"